import { createAsyncThunk } from '@reduxjs/toolkit';
import { restoreTagsFromJsonQuery } from '../../../packages/Tags';
import { IThunkApi } from 'shared/types/redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectPromoSearchTypes } from 'shared/selectors/promoSearchTypes';
import { selectTagsMeta } from 'shared/selectors/tags';
import { selectLocation } from 'shared/selectors/location';
import { fetchGeoTagsSafe } from 'shared/services/fetchGeoTags';
import { setGeoTags, setNeedUpdateGeoTags, setTags } from 'shared/slices/tags';
import { isEmpty } from 'ramda';
import { selectGeoTags } from 'shared/selectors/tags/selectGeoTags';
import { selectCoworkingNames } from 'shared/selectors/tags/selectCoworkingNames';
import { selectSpecialtyTypeOptionsRaw } from 'shared/selectors/filters/specialtyTypes/selectSpecialtyTypesOptions';

export const updateTags = createAsyncThunk<void, boolean | undefined, IThunkApi>(
  'tags/update',
  async (needUpdateGeoTags, { getState, extra: context, dispatch }) => {
    const {
      config,
      custom: { subdomain },
    } = context;
    let state = getState();

    const jsonQuery = selectJsonQuery(state);
    const location = selectLocation(state);
    const promoSearchTypes = selectPromoSearchTypes(state);
    const {
      undergroundsUnderConstruction,
      village,
      directions,
      needUpdateGeoTags: needUpdateGeoTagsFromState,
    } = selectTagsMeta(state);

    if (needUpdateGeoTags || needUpdateGeoTagsFromState) {
      const geoTags = await fetchGeoTagsSafe(context, {
        jsonQuery,
        subdomain,
        undergroundsUnderConstruction,
        directions,
        village,
      });

      if (!isEmpty(geoTags)) {
        dispatch(setGeoTags(geoTags));
      }

      dispatch(setNeedUpdateGeoTags(false));
    }

    state = getState();

    const geoTags = selectGeoTags(state);
    const coworkingNames = selectCoworkingNames(state);

    const specialtyTypeOptions = selectSpecialtyTypeOptionsRaw(state);

    const tags = restoreTagsFromJsonQuery({
      jsonQuery,
      location,
      config,
      promoSearchTypes,
      geoTags,
      specialtyTypeOptions,
      coworkingNames,
    });

    dispatch(setTags(tags));
  },
);
